import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AgGridModule } from 'ag-grid-angular';
import { NgbModule, NgbPaginationModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonLoadingComponent } from './common-loading/common-loading.component';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { FlatpickrModule } from 'angularx-flatpickr';
import { allIcons } from 'angular-feather/icons';
import { FeatherModule } from 'angular-feather';
import { RouterModule } from '@angular/router';
import { FromErrorComponent } from './from-error/from-error.component';
import { TranslateModule } from '@ngx-translate/core';
import { ConfirmationModalComponent } from './confirmation-modal/confirmation-modal.component';
import { DropzoneModule } from 'ngx-dropzone-wrapper';
import { CommonDropzoneComponent } from './dropzone/dropzone.component';
import { FormErrorComponent } from './form-error/form-error.component';
import { TrimInputDirective } from '@app/core/directives/trim-input.directive';
@NgModule({
  declarations: [
    CommonLoadingComponent,
    FromErrorComponent,
    ConfirmationModalComponent,
    CommonDropzoneComponent,
    FormErrorComponent,
    TrimInputDirective,
  ],
  imports: [
    CommonModule,
    AgGridModule,
    NgbPaginationModule,
    NgSelectModule,
    FormsModule,
    NgxSkeletonLoaderModule,
    FlatpickrModule.forRoot(),
    FeatherModule.pick(allIcons),
    RouterModule,
    TranslateModule,
    DropzoneModule,
    FormsModule,
    ReactiveFormsModule,
    NgbTooltipModule,
    NgbModule,
  ],
  exports: [
    CommonLoadingComponent,
    FromErrorComponent,
    CommonDropzoneComponent,
    FormErrorComponent,
    TrimInputDirective,
  ],
})
export class SharedModule {}
